// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3e-jG","ranges":"BmiRanges_ranges__3zRL8"};